import { Button, Stack, Typography } from "@mui/material";

import { InventoryItem } from "../../../models";
import { ButtonLoading, ModalContainer } from "../../ui";

interface Props {
  open: boolean;
  candidates: InventoryItem[];
  onClose: () => void;
  onCreateAnyway: () => void | Promise<void>;
}

export const DuplicateInventoryItemPrompt = (props: Props) => {
  const { open, candidates, onClose, onCreateAnyway } = props;

  return (
    <ModalContainer
      open={open}
      handleClose={onClose}
      title="Possible duplicate inventory item found"
    >
      <Stack spacing={2} sx={{ minWidth: 640 }}>
        <Typography variant="body1">
          We found inventory items that match the entered name. Are you sure you
          want to save this item?
        </Typography>
        <Stack spacing={1}>
          {candidates.map((candidate) => (
            <Stack
              key={candidate.id}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              sx={{ border: "1px solid", borderColor: "divider", p: 1.5 }}
            >
              <Stack>
                <Typography variant="subtitle1">{candidate.name}</Typography>
                <Typography variant="body2">
                  {[candidate.inventoryType?.name, candidate.model, candidate.sku]
                    .filter(Boolean)
                    .join(" | ")}
                </Typography>
              </Stack>
              <Typography variant="body2">
                ${Number(candidate.price ?? 0).toFixed(2)}
              </Typography>
            </Stack>
          ))}
        </Stack>
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <ButtonLoading variant="contained" onClick={onCreateAnyway}>
            Save anyway
          </ButtonLoading>
        </Stack>
      </Stack>
    </ModalContainer>
  );
};
